import React from 'react';
import "./../Component_css/Footer.css";

function Footer() {
  return (
    <div className = "footer">
      <div className="footer__text">
      "All rights reserved. © Artisans-United 2023"

      </div>
      <div className="footer__copyRyt">
      This site has been made by Aaryan Mahajan
      </div>
    </div>
  )
}

export default Footer
